import { getObject } from "../ChoiceApi";

export async function getPracticeOrganizationId(): Promise<string|undefined>
{
    return await getObject("api/SurescriptsDirectory/Practice/Organization/Id");
}